export type AppStorePlatform = 'android' | 'ios' | 'macos' | 'other'

/**
 * Classify only what is needed for CTA routing and reporting. This deliberately
 * avoids high-entropy device details: analytics receives a four-value bucket,
 * never the raw user agent.
 */
export function classifyAppStorePlatform(userAgent: string): AppStorePlatform {
  if (/android/i.test(userAgent)) return 'android'
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios'
  if (/macintosh|mac os x/i.test(userAgent)) return 'macos'
  return 'other'
}

export type InstallPlatform = 'ios' | 'android' | 'desktop'

/**
 * Which install path a visitor gets: a phone goes straight to its own store,
 * anything else is shown the scan-to-install code. iPadOS Safari reports a
 * Mac user agent, so on the client a Mac with touch points counts as iOS.
 */
export function classifyInstallPlatform(userAgent: string, maxTouchPoints = 0): InstallPlatform {
  const platform = classifyAppStorePlatform(userAgent)
  if (platform === 'ios' || platform === 'android') return platform
  if (platform === 'macos' && maxTouchPoints > 1) return 'ios'
  return 'desktop'
}
